/** @format */

import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import * as yup from "yup";
import ReactTagInput from "@pathofdev/react-tag-input";
import "src/assets/scss/socialv-design-system/components/react-tag/_react-tag.scss";
import { useCreateUserSkill } from "../../../../../../api/mutations/user.mutation";

function SkillsForm() {
  const [tags, setTags] = useState([]);

  const userSkillMutation = useCreateUserSkill({
    onSuccess: () => {
      console.log("Success");
    },
    onError: (error) => {
      console.error("Failed to create experience:", error.message);
      console.error(
        "Error response:",
        error.response ? error.response.data : error
      );
    },
  });

  const formik = useFormik({
    initialValues: {
      skills: [],
    },
    onSubmit: (values) => {
      console.log(values);
      values.skills.forEach((skill) => {
        userSkillMutation.mutate({
          name: skill,
        });
      });
    },
  });

  const handleTagChange = (newTags) => {
    setTags(newTags);
    formik.setFieldValue("skills", newTags);
  };

  return (
    <Form noValidate onSubmit={formik.handleSubmit} className="mt-5">
      <Row className="mb-2">
        <Form.Group
          as={Col}
          controlId="validationFormikSkills"
          className="form-group text-start"
        >
          <Form.Label className="form-label fw-bold">Your Skills</Form.Label>
          <ReactTagInput
            tags={tags}
            placeholder="Type a skill and press enter..."
            onChange={handleTagChange}
          />
        </Form.Group>
      </Row>
      <div className="text-end">
        <Button
          variant="success"
          type="submit"
          className="btn btn-success mt-4 fw-semibold text-uppercase"
        >
          Save & Update
        </Button>
      </div>
    </Form>
  );
}

export default SkillsForm;
